import { useState, type ReactNode } from 'react';
import Icon from './Icon';

/**
 * Фильтры — третий примитив админки.
 *
 * На широком экране строкой: у администратора клавиатура и место, и
 * раскрывать панель незачем. На телефоне свёрнуты в кнопку со счётчиком —
 * иначе они съедают первый экран, ради которого на вкладку и заходят.
 *
 * Приём не новый: так уже сделана лента заявок, и повторить его здесь
 * дешевле, чем придумать второй. Счётчик обязателен — свёрнутая панель
 * без него не отвечает на вопрос «почему список пустой».
 */

interface Props {
  /** Поиск: он всегда на виду, даже когда остальное свёрнуто. */
  search: ReactNode;
  /** Всё прочее: чипы, выпадающие списки. */
  children: ReactNode;
  /** Сколько фильтров задано — цифра на кнопке. */
  active: number;
}

export default function AdminFilters({ search, children, active }: Props) {
  const [open, setOpen] = useState(false);

  return (
    <div className="afilters">
      <div className="afilters__top">
        <div className="afilters__search">{search}</div>

        {/* Кнопка только на телефоне: на вебе фильтры и так на виду. */}
        <button
          type="button"
          className="secondary afilters__toggle"
          onClick={() => setOpen((v) => !v)}
          aria-expanded={open}
        >
          <Icon name="filter" size={15} />
          Фильтры{active > 0 ? ` · ${active}` : ''}
        </button>
      </div>

      <div className={open ? 'afilters__rest is-open' : 'afilters__rest'}>{children}</div>
    </div>
  );
}
